import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SelectedFilters } from 'rio-models';
import { Prompt } from './models';

export const promptsActions = createActionGroup({
  source: 'Prompts',
  events: {
    'Check Load Prompts': emptyProps(),
    'Load Prompts': emptyProps(),
    'Load Prompts Success': props<{ prompts: Prompt[] }>(),
    'Load Prompts Failure': emptyProps(),

    loadFilteredPromptsWithEmptyFilters: props<{ filters: undefined }>(),
    loadFilteredPrompts: props<{ filters: SelectedFilters }>(),
    loadFilteredPromptsSuccess: props<{ prompts: Prompt[] }>(),
    loadFilteredPromptsFailure: emptyProps(),

    'Delete Prompt': props<{ promptId: string }>(),
    'Delete Prompt Success': props<{ promptId: string }>(),
    'Delete Prompt Failure': emptyProps(),

    'Clear All Prompts': emptyProps(),
  },
});
